import { render } from "./ShowRole.vue?vue&type=template&id=4a1a8331"
import script from "./ShowRole.vue?vue&type=script&lang=js"
export * from "./ShowRole.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__